export const RefTypeBranch = 'branch';
export const RefTypeCommit = 'commit';
export const RefTypeTag = 'tag';
